import { FC } from 'react';
import { Button, Modal } from 'antd';
import { useAuth } from 'lib.context/src/AuthContext';
import { TextBodyRegular } from 'lib.typography';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onEnablePro: () => void;
};

/**
 * The launch paywall: every Launch / Resume / Enable control the backend
 * refuses for want of an active Boost PRO (a 422 on `subscription`) lands
 * here — one window for all of them, mounted once by `BillingProvider`.
 * Its button opens Billing's own Enable PRO flow; the sponsor launches again
 * once PRO is on.
 */
const ProRequiredModal: FC<Props> = ({ isOpen, onClose, onEnablePro }) => {
  const {
    proSubscriptionData: { formattedProPrice },
  } = useAuth();

  return (
    <Modal
      title="Boost PRO is required to launch"
      open={isOpen}
      onCancel={onClose}
      centered
      width={440}
      footer={
        <div className="flex justify-end">
          <Button size="large" type="text" onClick={onClose} className="mr-6">
            Not now
          </Button>
          {/* PRO's own call: the PRO gradient */}
          <Button
            size="large"
            type="primary"
            className="btn-pro"
            onClick={onEnablePro}
            data-test-id="pro-required-enable-pro"
          >
            Enable Boost PRO
          </Button>
        </div>
      }
    >
      <TextBodyRegular data-test-id="pro-required-modal">
        Every campaign runs with Boost PRO, your campaign manager — we test, retire and scale; you
        approve the work.
        {formattedProPrice ? ` ${formattedProPrice} a month.` : ''}
      </TextBodyRegular>
    </Modal>
  );
};

export default ProRequiredModal;
